import { FolderAccountOutlineIcon } from './FolderAccountOutlineIcon';

/**
 * author: Google
 * id B905BF65-7312-4F62-8979-EDB2906B38E6
 * name folder-account-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-account-outline.svg
 * tags
 * - Files / Folders 
 * - Account / User 
 */
export const FolderSharedOutlineIcon = FolderAccountOutlineIcon;
export default FolderSharedOutlineIcon